function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.29 14.19l-5.54 1.1M3.68 14.2h2.45l3.51 3.94a1.41 1.41 0 001 .46 46.18 46.18 0 005.74-4.89c.11-.31-.1-.62-.29-.88l-2.51-3.24m-3-2.51l-.35-.3A2.16 2.16 0 009 6.38a2.08 2.08 0 00-.78.15L3.75 8.31",
  fill: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.75 6.6h2a1 1 0 011 .92v6.42a1 1 0 01-1 .91h-2m22.5 0h-2a1 1 0 01-1-.91V7.52a1 1 0 011-.92h2m-8.5 2.6l-3.45 1.14a1.61 1.61 0 01-2-.86 1.63 1.63 0 01.74-2.14l3.36-1.69a2.3 2.3 0 011.06-.25 2.45 2.45 0 01.8.14l5 1.82",
  fill: "none"
});

function SvgBusinessDealHandshake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgBusinessDealHandshake;